/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Risks_XriskInputs */

const en_footer_risks_xrisk = /** @type {(inputs: Footer_Risks_XriskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existential risk`)
};

/**
* | output |
* | --- |
* | "Existential risk" |
*
* @param {Footer_Risks_XriskInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks_xrisk = /** @type {((inputs?: Footer_Risks_XriskInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Risks_XriskInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks_xrisk(inputs)
});